export const Any = '*';
export const Admin = 'admin';
export const ProjectLeader = 'projectleader';
export const Trial = 'trial';
export const SiteManager = 'sitemanager';
export const SiteAssistant = 'siteassistant'; // add new role same as SiteManager
export const SubContractor = 'subcontractor';
export const Client = 'client';
export const Special = '!!';

export default {
  Any,
  Admin,
  ProjectLeader,
  Trial,
  SiteManager,
  SiteAssistant,
  SubContractor,
  Client,
  Special,
};



// WEBPACK FOOTER //
// ./src/store/roles.js